import Commons from "oc-commons/Commons.js";
import Scenes from "../Scenes.js";
import "../patched/TextureLoader.oc.js";
import "oc-commons/extensions/StringExtensions.js";
import "../patched/MTLLoader.oc.js";
import "three/examples/js/loaders/OBJLoader.js";
import "three/examples/js/loaders/ColladaLoader.js";
import "three/examples/js/loaders/STLLoader.js";
import "three/examples/js/loaders/TDSLoader.js";
import * as fflate from "fflate/lib/browser.cjs"; // für FBXLoader
import "three/examples/js/loaders/FBXLoader.js";
import "three/examples/js/loaders/GLTFLoader.js";
import "three/examples/js/loaders/RGBELoader.js";
import Textures from "../Textures";
import Urls from "oc-commons/Urls";

window.fflate = fflate;

const wrappedProgressEventRejectWorkaround = (reject) => (error) => {
    // debugger;
    // Aus irgend einem komischen Grund kommt hier ProgressEvent als Rückgabe bei einem 404 an !?!?
    if (error instanceof ProgressEvent) {
        return reject(
            new Error(
                JSON.stringify({
                    status: _.get(error, "target.status"),
                    statusText: _.get(error, "target.statusText"),
                    url: _.get(error, "target.responseURL"),
                })
            )
        );
    }
    return reject(error);
};

const startEndLoadingEventPromiseEvenIfCached = (promise) => {
    const loadingManager = UniversalLoader.INSTANCE.loadingManager;
    const url = "cache";
    loadingManager.itemStart(url);
    return promise.then(
        (object) => {
            loadingManager.itemEnd(url);
            return object;
        },
        (error) => {
            loadingManager.itemError(url);
            throw error;
        }
    );
};

const objectClonerPromise = (promise) => {
    // clone, damit nur einmal geladen aber mehrmals instanziiert werden kann
    // Material und Geometry werden dabei nur als Referenz kopiert
    return startEndLoadingEventPromiseEvenIfCached(
        promise.then((object) => {
            if (object) {
                const animationClips = object.animationClips;
                object = object.clone();
                object.animationClips = animationClips;
            }
            return object;
        })
    );
};

const triggerLoadedDebounced = _.debounce(
    () => {
        STAGE.trigger("loadingManagerOnLoad");
        STAGE.dirty();
    },
    100,
    { maxWait: 3000 }
);

/**
 * MEGA-UGLY-FIX, damit man das Laden eines Images mitkriegen kann....
 * FIXME besser dazu in den Textureloader gehen...
 */
Commons.monkeyProperty(THREE.Texture.prototype, "image", {
    get() {
        return this.image_;
    },
    set(image) {
        this.image_ = image;
        if (this.setImageCallback) {
            this.setImageCallback(image);
        }
    },
});

class MyLoadingManager {
    isLoading = false;
    itemsLoaded = 0;
    itemsError = 0;
    itemsTotal = 0;
    urlModifier = null;

    itemStart(url) {
        // console.log('itemStart',url);
        this.itemsTotal++;
        this.isLoading = true;
    }

    itemEnd(url) {
        //        console.log('itemEnd',url);
        this.itemsLoaded++;
        this.checkLoaded();
    }

    itemError(url) {
        //        console.log('itemError',url);
        console.warn("UniversalLoadingManager.onError", url);
        this.itemsError++;
        this.checkLoaded();
    }

    checkLoaded() {
        if (this.itemsLoaded + this.itemsError < this.itemsTotal) {
            return;
        }
        this.isLoading = false;
        triggerLoadedDebounced();
    }

    resolveURL(url) {
        if (this.urlModifier) {
            return this.urlModifier(url);
        }
        return url;
    }

    setURLModifier(transform) {
        this.urlModifier = transform;
        return this;
    }

    getHandler(url) {
        return new THREE.LoadingManager().getHandler(url);
    }

    reset() {
        this.isLoading = false;
        this.itemsLoaded = 0;
        this.itemsError = 0;
        this.itemsTotal = 0;
        this.urlModifier = null;
    }
}

/**
 * UniversalLoader lädt verschiedene Formate und bietet Caching und Nachverfolgen von Ladefehlern
 * und Events für den gesamten Ladevorgang
 */
class UniversalLoader {
    static INSTANCE = new UniversalLoader();

    constructor() {
        this.cache = {};
        this.cacheEnabled = true;

        // enable general caching in ThreeJS, but not for Models (this is done by our own cache) see this._callLoad
        THREE.Cache.enabled = true;

        // allow CORS
        this.crossOrigin = "anonymous";
        THREE.ImageUtils.crossOrigin = this.crossOrigin;

        // der von UniversalLoader benutzte Loadingmanager
        this.loadingManager = new MyLoadingManager();
    }

    /**
     * lädt eine MTL-Datei. Achtung: Erst wenn successCallback aufgerufen wird,
     * darf man Modelle laden! Ansonsten wundert man sich, dass Modelle weiß sind..
     */
    loadMTL(mtlUrl, successCallback, errorCallback, progressCallback) {
        var mtlLoader = new THREE.MTLLoader(this.loadingManager);
        let path = mtlUrl.substringBeforeLast("/");
        if (!(Commons.isEmpty(path) || path.endsWith("/"))) {
            path += "/";
        }
        mtlLoader.setTexturePath(path);
        mtlLoader.setPath(path);
        mtlLoader.load(
            mtlUrl.substringAfterLast("/"),
            (materials) => {
                materials.preload();
                successCallback(materials);
            },
            progressCallback,
            errorCallback
        );
    }

    /** */
    setMaterialFactory(materialsFactory) {
        this.materialFactory = materialsFactory;
    }

    getMaterialFactory() {
        return this.materialFactory;
    }

    /**
     * lädt ein Modell, entweder STL, DAE, JS oder OBJ
     * @param urlsArray ["Modellname.extension"], im Falle einer OBJ-Datei können es auch zwei
     *     Namen sein ["Modell.OBJ","DieMaterialien.MTL"]
     * @param successCallback
     * @param errorCallback
     * @param progressCallback deprecated!
     * @param materialsFactory
     * @param cacheKey
     */
    loadModel(
        urlsArray,
        successCallback = undefined,
        errorCallback = undefined,
        progressCallback = undefined,
        materialsFactory = undefined,
        cacheKey = undefined
    ) {
        if (progressCallback) {
            console.warn("UniversalLoader.loadModel progressCallback is deprecated");
        }
        let promise = this.loadModelPromise(urlsArray, materialsFactory, cacheKey);
        promise.then(successCallback, errorCallback);
    }

    /**
     * lädt ein Modell, entweder STL, DAE, JS oder OBJ
     * @param {(string | string[])} urlOrArray die URL der Modelldatei wie "Modellname.extension", im Falle einer
     *     OBJ-Datei können es auch zwei Namen sein ["Modell.OBJ","DieMaterialien.MTL"]
     * @param {*} [materialsFactory=undefined] optional eine AbstractMaterialFactory
     * @param {*} [cacheKey=undefined] optional, ein String. Sollte bei der Verwendung einer
     *     ReplacingMaterialsFactory gesetzt sein!
     * @returns {Promise<THREE.Object3D>} Promise mit dem geladenen THREE.Objekt3D
     */
    loadModelPromise(
        urlOrArray,
        materialsFactory = undefined,
        cacheKey = undefined
    ) {
        if (Commons.isEmpty(urlOrArray)) {
            return Promise.resolve(null);
        }

        if (materialsFactory) {
            const orig = materialsFactory;
            materialsFactory = {
                create: (name)=>{
                    const mat = orig.create(name);
                    return mat;
                }
            }
        }

        this.startSomeLoading();

        const urls = typeof urlOrArray === "string" ? [urlOrArray] : urlOrArray;

        const cacheKeyIntern = cacheKey == null ? urls.join("|") : cacheKey;

        let promise;

        if (this.cacheEnabled) {
            promise = this.cache[cacheKeyIntern];
            // console.log('cache access',cacheKeyIntern,promise);
            if (promise) {
                return objectClonerPromise(promise);
            }
        }

        promise = this._loadModelPromise(urls, materialsFactory);

        if (this.cacheEnabled) {
            this.cache[cacheKeyIntern] = promise;
            // console.log('cache write',cacheKeyIntern,this.cache[cacheKeyIntern]);

            promise = objectClonerPromise(promise);
        }

        return promise;
    }

    /** */
    getPromiseAllImagesLoaded(promise) {
        return promise.then((object3D) => {
            const materials = Textures.getMaterials(object3D);
            let promises = [];

            materials.forEach((mat) => {
                for (let textureKey in mat) {
                    const texture = mat[textureKey];
                    if (!texture?.isTexture) continue;
                    if (texture.image) continue;
                    texture.promise =
                        texture.promise ||
                        new Promise((resolve, reject) => {
                            texture.promiseResolve = resolve;
                            texture.promiseReject = reject;
                        });
                    promises.push(texture.promise);
                }
            });
            // promise returnen was resolved wenn alle images geladen sind.
            return Promise.all(
                promises.map(
                    (p) => p.then(() => "ok"),
                    () => "error"
                )
            ).then(() => {
                // console.log(Textures.getMaterialNames(object3D),Textures.getMaterials(object3D).map(m=>m.map));
                return object3D;
            });
        });
    }

    canLoadModelFileExtension(url) {
        return this._getLoadMethod(url) != null;
    }

    /**
     *
     * @param url
     * @private
     */
    _getLoadMethod(url) {
        const extension = Urls.urlSplit(url).path.substringAfterLast(".").toUpperCase();
        const loadMethodName = "_load" + extension;
        return this[loadMethodName];
    }

    /**
     * @private
     * @returns {Promise}
     */
    _loadModelPromise(urls, materialsFactory) {
        // Finde den passenden Loader per Reflection (this._load<SUFFIX>)
        let url;
        let method;
        findLoader: {
            for (url of urls) {
                method = this._getLoadMethod(url);
                if (method) {
                    break findLoader;
                }
            }
            console.warn("UniversalLoader.loadModel unknown file format " + urls.join(", "));
            return Promise.reject("unknown file format " + urls.join(", "));
        }

        // Führe den eigentlichen Loader aus
        let promise = new Promise((resolve, reject) => {
            // console.log('start loading',url);
            method.call(
                this,
                url,
                urls,
                resolve,
                undefined,
                wrappedProgressEventRejectWorkaround(reject),
                materialsFactory
            );
        });

        promise = promise.then((object) => {
            // console.log('loaded',url);

            if (object) {
                // Füge dem Objekt den Dateinamen hinzu
                object.name = url.substringAfterLast("/");

                // if an OBJ is loaded, add a second UV map for AOmap usage
                if (/obj$/i.test(url)) {
                    object.children.forEach((child) => {
                        if (child.geometry.attributes.uv)
                            child.geometry.setAttribute(
                                "uv2",
                                new THREE.Float32BufferAttribute(
                                    child.geometry.attributes.uv.array,
                                    2
                                )
                            );
                    });
                }
                // prevent and find out the following warning:
                // THREE js imported OBJ model [.CommandBufferContext]RENDER WARNING: Render count or primcount is 0
                Scenes.removeZeroFaceOrVerticesChildren(object);
            }
            return object;
        });

        return promise;
    }

    /**
     * @private
     */
    _loadOBJ(url, urls, successCallback, progressCallback, errorCallback, materialsFactory) {
        const mtlUrl = urls.find((url) => /^.*\.mtl$/i.test(url));
        const loadObj = (materials) => {
            const objLoader = new THREE.OBJLoader(this.loadingManager);
            const mat = materials || materialsFactory || this.materialFactory;
            if (mat) {
                objLoader.setMaterials(mat);
            }
            this._callLoad(objLoader, url, successCallback, progressCallback, errorCallback);
        };
        if (mtlUrl) {
            this.loadMTL(
                mtlUrl,
                loadObj,
                (error) => {
                    // die MTL wird als optional betrachtet. 404 wird durch den FileLoader als Warning geloggt.
                    loadObj(null);
                },
                progressCallback
            );
        } else {
            loadObj(null);
        }
    }

    /**
     * @private
     */
    _loadWRL(url, urls, successCallback, progressCallback, errorCallback) {
        const loader = new THREE.VRMLLoader(this.loadingManager);
        loader.texturePath = url.substringBeforeLast("/");
        this._callLoad(loader, url, successCallback, progressCallback, errorCallback);
    }

    /**
     * @private
     */
    _loadSTL(url, urls, successCallback, progressCallback, errorCallback, materialsFactory) {
        const loader = new THREE.STLLoader(this.loadingManager);
        this._callLoad(
            loader,
            url,
            (geometry, b, c) => {
                let material;
                if (materialsFactory) {
                    material = materialsFactory.create("");
                } else if (this.materialFactory) {
                    material = this.materialFactory.create("");
                }
                material = material ? material : new THREE.MeshPhongMaterial();
                const object3d = new THREE.Mesh(geometry, material);
                successCallback(object3d);
            },
            progressCallback,
            errorCallback
        );
    }

    /**
     * @private
     */
    _loadDAE(url, urls, successCallback, progressCallback, errorCallback) {
        const loader = new THREE.ColladaLoader(this.loadingManager);
        loader.options.convertUpAxis = true;
        this._callLoad(
            loader,
            url,
            (object) => {
                if (object.scene) {
                    object = object.scene;
                }
                successCallback(object);
            },
            progressCallback,
            errorCallback
        );
    }

    /**
     * @private
     */
    _loadJS(url, urls, successCallback, progressCallback, errorCallback) {
        const loader = new THREE.JSONLoader(this.loadingManager);
        this._callLoad(
            loader,
            url,
            (geometry, materials) => {
                let material;
                if (materials.length > 1) {
                    material = new THREE.MeshFaceMaterial(materials);
                } else {
                    material = materials[0];
                }
                const object3d = new THREE.Mesh(geometry, material);
                successCallback(object3d);
            },
            progressCallback,
            errorCallback
        );
    }

    /**
     * @private
     */
    _load3DS(url, urls, successCallback, progressCallback, errorCallback, materialsFactory) {
        const loader = new THREE.TDSLoader(this.loadingManager);
        this._callLoad(
            loader,
            url,
            (geometry, materials) => {
                let material;
                if (materials.length > 1) {
                    material = new THREE.MeshFaceMaterial(materials);
                } else {
                    material = materials[0];
                }
                const object3d = new THREE.Mesh(geometry, material);
                successCallback(object3d);
            },
            progressCallback,
            errorCallback
        );
    }

    /**
     * @private
     */
    _loadGLTF(url, urls, successCallback, progressCallback, errorCallback, materialsFactory) {
        const loader = new THREE.GLTFLoader(this.loadingManager);
        this._callLoad(
            loader,
            url,
            (gltf) => {
                gltf.scene.sourceFile = url;
                this._setMaterialsFromFactoryToObject(gltf.scene, materialsFactory);
                if (!Commons.isEmpty(gltf.animations)) {
                    gltf.scene.animationClips = gltf.animations;
                }
                successCallback(gltf.scene);
            },
            progressCallback,
            errorCallback
        );
    }

    /**
     * @private
     */
    _loadGLB(url, urls, successCallback, progressCallback, errorCallback, materialsFactory) {
        return this._loadGLTF(
            url,
            urls,
            successCallback,
            progressCallback,
            errorCallback,
            materialsFactory
        );
    }

    /**
     * @private
     */
    _loadFBX(url, urls, successCallback, progressCallback, errorCallback, materialsFactory) {
        const loader = new THREE.FBXLoader(this.loadingManager);
        this._callLoad(
            loader,
            url,
            (sceneGraph) => {
                this._setMaterialsFromFactoryToObject(sceneGraph, materialsFactory);
                const mixer = new THREE.AnimationMixer(sceneGraph);
                STAGE.animations[url.substringAfterLast("/")] = {
                    animations: sceneGraph.animations,
                    mixer: mixer,
                };
                successCallback(sceneGraph);
            },
            progressCallback,
            errorCallback
        );
    }

    /**
     * @param object Object3d
     * @param materialsFactory
     * @private
     */
    _setMaterialsFromFactoryToObject(object, materialsFactory) {
        if (materialsFactory == null) {
            return;
        }

        const swap = (m) => {
            const newM = materialsFactory.create(m.name);
            return newM && !newM._no_material_with_this_name_found ? newM : m;
        };

        Scenes.filter(object, (o) => o.material != null).forEach((o) => {
            if (Array.isArray(o.material)) {
                o.material = o.material.map(swap);
            } else {
                o.material = swap(o.material);
            }
        });
    }

    /**
     * von THREE.ImageUtils.loadTexture kopiert mit dem Unterschied, dass der loadingManager
     * vom UniversalLoader benutzt wird
     */
    loadTexture(url, mapping, onLoad, onError, theCrossOrigin = this.crossOrigin) {
        if (url.endsWith("hdr")) {
            return this.loadHdrTexture(url, mapping, onLoad, onError, theCrossOrigin);
        }

        const loader = new THREE.TextureLoader(this.loadingManager);
        loader.setCrossOrigin(theCrossOrigin);

        onError =
            onError ||
            (() => console.warn("UniversalLoader.loadTexture error loading " + url, arguments));
        const texture = loader.load(url, onLoad || undefined, undefined, onError);
        texture.sourceFile = url;

        if (mapping) {
            texture.mapping = mapping;
        }

        return texture;
    }

    loadHdrTexture(url, mapping, onLoad, onError, theCrossOrigin = this.crossOrigin) {

        onLoad = ( texture ) => {
            var pmremGenerator = new THREE.PMREMGenerator( STAGE.renderer );
            pmremGenerator.compileEquirectangularShader();
            var envMap = pmremGenerator.fromEquirectangular( texture ).texture;

            STAGE.scene.environment = envMap;

            texture.dispose();
            pmremGenerator.dispose();
        };
        const loader = new THREE.RGBELoader(this.loadingManager);
        loader.setCrossOrigin(theCrossOrigin);
        loader.setDataType(THREE.FloatType); // alt: UnsignedByteType oder FloatType oder HalfFloatType

        onError =
            onError ||
            (() => console.warn("UniversalLoader.loadTexture error loading " + url, arguments));
        const texture = loader.load(url, onLoad || undefined, undefined, onError);
        texture.sourceFile = url;

        if (mapping) {
            texture.mapping = mapping;
        }

        return texture;
    }

    /**
     * Lädt einen TextureCube
     */
    loadTextureCube(urls, mapping, onLoad, onError, theCrossOrigin = this.crossOrigin) {
        try {
            const loader = new THREE.CubeTextureLoader(this.loadingManager);
            loader.setCrossOrigin(theCrossOrigin);

            onError =
                onError ||
                (() =>
                    console.warn(
                        "UniversalLoader.loadTextureCube error loading " + urls.join(", "),
                        arguments
                    ));

            const textureCube = loader.load(urls, onLoad || undefined, undefined, onError);

            textureCube.format = THREE.RGBFormat;
            textureCube.sourceFiles = urls;

            return textureCube;
        } catch (e) {
            console.warn("error loading cube textures ", urls, e);
            return null;
        }
    }

    /**
     * ruft Callback auf, sobald alles geladen wurde
     */
    delayUntilEverythingLoaded(callback, nameForDebugging = "", timeOutCallback = () => {}) {
        Commons.delayUntil(
            callback,
            () => this.isEverythingLoaded(),
            20 * 1000,
            1,
            () => {
                console.warn(
                    "UniversalLoader.delayUntilEverythingLoaded timeout warning for ",
                    nameForDebugging,
                    callback
                );
                this.setEverythingLoaded();
                timeOutCallback();
            }
        );
    }

    /** */
    startSomeLoading() {
        this.loadingManager.isLoading = true;
    }

    /**
     * true, wenn zur Zeit keine Ladevorgänge laufen
     */
    isEverythingLoaded() {
        return !this.loadingManager.isLoading;
    }

    /** */
    setEverythingLoaded() {
        this.loadingManager.reset();
    }

    // /**
    //  * Texturreferenzen enthalten oft falsche Pfade.
    //  * Dieser Loader lädt Texturen immer aus einem definierten Basis-Pfad,
    //  * unabhängig davon, was in den Materialdateien für Pfade stehen
    //  */
    // initThreejsTextureLoaderHandlerOnce(basePath) {
    //     THREE.Loader.Handlers.add(/.*/g, {
    //         load : function(path, callback) {
    //             var filename = path.substringAfterLast('/');
    //             if (typeof this.cache[filename] !== 'undefined') {
    //                 return this.cache[filename];
    //             }
    //             var url = basePath + filename;
    //             console.log('LOADER ',url);
    //             var texture = this.loadTexture(url, function() {
    //                 //console.log("texture loaded: " + filename);
    //             }, undefined, function(error) {
    //                 console.warn("can't load texture " + url, error);
    //             });
    //             this.cache[filename] = texture;
    //             return texture;
    //         }
    //     });
    // }

    _callLoad(loader, url, successCallback, progressCallback, errorCallback) {
        // Da UniversalLoader selbst cached, sollte der Loader-Cache (der nur auf FileLoader-Ebene gecached ist und immer noch mal parst) ausgeschaltet werden,
        // ansonsten wird der File-Content beibehalten, welcher recht groß sein kann
        let cachedBefore = THREE.Cache.enabled;
        const resetCacheEnable = (callback) => (...args) => {
            THREE.Cache.enabled = cachedBefore;
            if (callback) {
                return callback(...args);
            }
        };
        try {
            THREE.Cache.enabled = false;
            loader.load(
                url,
                resetCacheEnable(successCallback),
                resetCacheEnable(progressCallback),
                resetCacheEnable(errorCallback)
            );
        } catch (e) {
            THREE.Cache.enabled = cachedBefore;
            throw e;
        }
    }
}

export default UniversalLoader.INSTANCE;
